import { green, grey, red } from '@mui/material/colors'

export const styles = (theme) => ({
  a: {
    fontSize: '13pt',
    color: '#fff',
    padding: '10px 20px',
    textAlign: 'center',
    textDecoration: 'none',
    background: '#e597ba',
    borderRadius: '8px',
    position: 'absolute',
    right: 10,
  },
  article0: {
    background: 'white',
    color: 'black',
    fontSize: '13pt',
    marginLeft:'80px',
    maxWidth: 1000,
    padding: '35px 15px 10px 15px',
    width: '90%',
  },
  article1: {
    background: 'white',
    color: 'black',
    fontSize: '13pt',
    marginLeft:'80px',
    maxWidth: 1000,
    padding: '30px 15px 20px 15px',
    width: '90%',
  },
  article2: {
    background: 'white',
    border: '1px solid #4d4e51',
    color: 'black',
    fontSize: '13pt',
    marginLeft:'80px',
    maxWidth: 1000,
    padding: '10px 15px 0px 15px',
    width: '90%',
  },
  article3: {
    border: '1px solid #5a5d63',
    color: 'black',
    fontSize: '13pt',
    marginTop: '20px',
    marginLeft:'80px',
    maxWidth: 1000,
    padding: '5px 15px 5px 15px',
    width: '90%',
  },
  article4: {
    background: 'white',
    color: 'black',
    fontSize: '13pt',
    marginLeft:'80px',
    maxWidth: 1000,
    padding: '50px 15px 5px 15px',
    width: '90%',
  },
  butto: {
    background: '#e597ba',
    border: '1px solid #4d4e51',
    borderRadius: '8px',
    color: '#fff',
    padding: '10px',
    fontSize: '14pt',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#ffbfdb',
      color: '#3c52b2',
      cursor: 'pointer'
    },
    position: 'absolute',
    right: 10,
  },
  buttoSecondary: {
    background: '#3c52b2',
    border: '1px solid #4d4e51',
    borderRadius: '8px',
    color: '#fff',
    padding: '10px',
    fontSize: '14pt',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#5d73d8',
      cursor: 'pointer'
    },
    '&:disabled': {
      opacity: 0.7,
      cursor: 'not-allowed',
    },
    position: 'absolute',
    right: 140,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  dateString: {
    textAlign: 'end',
    fontSize: '13pt',
  },
  divider: {
    border: '1px solid #000000',
    color: '#000000',
  },
  error: {
    fontSize: '20px',
    color: red[400],
  },
  finePrint: {
    fontSize: '11pt',
    color: 'black',
  },
  finePrint2: {
    fontSize: '11pt',
    color: 'black',
  },
  form: {
    width: '90%',
    marginLeft: 13,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    fontSize: 14,
  },
  imageContainer: {
    marginTop: '5rem',
    display: 'block',
    pageBreakBefore: 'always',
  },
  imageRoot: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  imageList: {
    marginLeft:'60px',
    width: 1000,
    height: 1500,
  },
  poptitle: {
    marginLeft: theme.spacing(2),
    width: 800,
  },
  pos: {
    marginBottom: 12,
  },
  printButton: {
    bottom: 0,
    left: 0,
    color: green
  },
  prodGrid: {
    color: grey[900],
    background: '#edf0f7',
  },
  prodGridInv: {
    width: 1000,
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#2b4287',
      color: '#f4f7ff',
      fontSize: 13,
    },
  },
  selectButton: {
    bottom: 0,
    right: 0,
  },
  subTitle: {
    fontSize: '20px',
    width: 400,
    color: grey[700],
    margin: '54px 0px 0px 0px',
    background: 'linear-gradient(45deg, #f2f0ea 30%, #b3acc1 90%)',
    borderRadius: '4px',
  },
  table: {
    marginLeft:'60px',
    maxWidth: 1000,
    background: '#edf0f7',
  },
  toolbar: theme.mixins.toolbar,
  uiProgess: {
    position: 'fixed',
    zIndex: '1000',
    height: '31px',
    width: '31px',
    left: '50%',
    top: '35%',
  },
  upAndBold: {
    textAlign: 'left',
    fontSize: '15pt',
    fontWeight: 'bold',
  },
  upAndLeft: {
    textAlign: 'left',
    fontSize: '12pt',
  },
  upAndRight: {
    fontSize: '12pt',
    textAlign: 'end',
  },
  upAndUnderline: {
    fontSize: '15pt',
    fontWeight: 'bold',
    textAlign: 'end',
    textDecoration: 'underline'
  },
  visitGrid: {
    color: grey[900],
    background: 'linear-gradient(45deg, #b3acc1 100%, #eeeae3 100%)'
  },
})
